import React from 'react';
import LeftMenu from './LeftMenu';
import {Link} from 'react-router-dom';
import NoResults from '../../components/NoResults';

import { months, host } from '../../assets/options';

import ReactHtmlParser from 'react-html-parser';

// TODO: Legacy fallback — extracts images from HTML desc for old entries
// that were created before the `img` field was added to the training model.
// New entries should use the dedicated `img` field (uploaded via control panel).
// Once all old entries are backfilled, this function can be removed.
// Uses the last image as card image since first images are often small icons/logos,
// while the last one tends to be the actual content photo.
const extractImages = (html) => {
    if (!html) return {imgSrc: null, cleanedHtml: html};

    const imgRegex = /<img[^>]+src=["']([^"']+)["'][^>]*>/gi;
    const matches = [...html.matchAll(imgRegex)];

    if (matches.length > 0) {
        const imgSrc = matches[matches.length - 1][1];
        const cleanedHtml = html.replace(imgRegex, '');
        return {imgSrc, cleanedHtml};
    }

    return {imgSrc: null, cleanedHtml: html};
};

const Item = props => {
    var item = props.data;

    item.date = new Date(item.date);

    // Prefer the dedicated `img` field (new entries).
    // Fall back to extracting from HTML desc (legacy entries).
    let cardImage = null;
    let descContent = item.desc;

    if (item.img) {
        cardImage = `url(${host}/public/uploads/${item.img})`;
    } else {
        const {imgSrc, cleanedHtml} = extractImages(item.desc);
        if (imgSrc) {
            cardImage = `url(${imgSrc})`;
            descContent = cleanedHtml;
        }
    }

    return (
        <a href={item.url} target="_blank" rel="noopener noreferrer" className="trainingCard">
            <div className="trainingCard__image"
                 style={{backgroundImage: cardImage || 'none', display: cardImage ? 'block' : 'none'}}>
            </div>
            <div className="trainingCard__content">
                <p className="trainingCard__date">
                    {months[item.date.getMonth()]} {item.date.getDate()}, {item.date.getFullYear()}
                </p>
                <h3 className="trainingCard__title">{item.name}</h3>
                <div className="trainingCard__desc">
                    {ReactHtmlParser(descContent)}
                </div>
            </div>
        </a>
    );
}

class Items extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            showAll: false,
            companyName: "",
            searchQuery: '',
        }
    }

    componentDidMount() {
        this.props.this.getData();
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            items: nextProps.data,
            companyName: nextProps.company
        });
    }

    handleSearchChange = (e) => {
        this.setState({searchQuery: e.target.value, showAll: false});
    }

    getFilteredItems() {
        const {items, searchQuery} = this.state;
        if (!searchQuery.trim()) return items;

        return items.filter(item =>
            item.name.toLowerCase().includes(searchQuery.toLowerCase())
        );
    }

    loadItems() {
        let items = [];
        const filteredItems = this.getFilteredItems();

        let mql = window.matchMedia('(max-width: 1024px)').matches;

        var length = (!this.state.showAll && mql && filteredItems.length > 3) ? 3 : filteredItems.length;

        for (var i = 0; i < length; i++) {
            items.push(<Item key={i} data={filteredItems[i]} handleOver={this.props.handleOver}
                             handleOut={this.props.handleOut}/>);
        }

        if (!this.state.showAll && mql && filteredItems.length > 3) items.push(<button key="seeMore"
                                                                                          className="seeMoreBtn"
                                                                                          onClick={() => {
                                                                                              this.setState({showAll: true})
                                                                                          }}>Տեսնել բოլորը</button>);

        return items;
    }

    render() {
        const filteredItems = this.getFilteredItems();

        return (
            <React.Fragment>
                <div className="MyBodyContainer trainings-page">
                    <div className="searchContainer trainings-search">
                        <input
                            type="text"
                            className="searchInput"
                            placeholder="Որոնել..."
                            value={this.state.searchQuery}
                            onChange={this.handleSearchChange}
                        />
                        <p className="SeachResults trainings-results-count">գտնվել է {filteredItems.length} դասընթաց</p>
                    </div>
                    {filteredItems.length === 0 && this.state.searchQuery.trim()
                        ? <NoResults searchQuery={this.state.searchQuery}/>
                        : <div className="trainingsGrid">
                            {this.loadItems()}
                        </div>
                    }
                </div>
            </React.Fragment>
        );
    }
}

export default Items;
